import { render } from "./edjec-feedback.vue?vue&type=template&id=76e4def2&scoped=true"
import script from "./edjec-feedback.vue?vue&type=script&lang=js"
export * from "./edjec-feedback.vue?vue&type=script&lang=js"

import "./edjec-feedback.vue?vue&type=style&index=0&id=76e4def2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76e4def2"]])

export default __exports__